module.exports = __webpack_public_path__ + "img/play.072b624e.svg";